import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/add.module.css";
import Info from "../Info/info";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

function Add({
  disabled,
  level,
  text,
  visibility,
  onClick,
  message,
  classname,
  color = "#0091EA",
}) {
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.InheritanceTree.add
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.InheritanceTree.add);
  }, [websiteCurrentLang]);
  return (
    <div
      className={classname ? styles.new_btn : styles.main}
      style={visibility ? { visibility: visibility } : null}
    >
      {classname ? (
        <button disabled={disabled} onClick={onClick} className={styles.btn}>
          {content.addText1}
        </button>
      ) : (
        <>
          <button
            disabled={disabled}
            onClick={onClick}
            className={styles.circle}
            style={{ background: color }}
          >
            <div className={styles.logo} />
          </button>
          <div className={styles.text}>
            {text ? text : content[`addText_priority_${level}`]}
            {message && <Info message={message} />}
          </div>
        </>
      )}
    </div>
  );
}

export default Add;
